import { Component } from '@angular/core';

@Component({
  selector: 'allas-necesitas-ayuda-con-tu-bateria',
  imports: [],
  template: `<section
    class="flex flex-col xl:flex-row xl:gap-16 items-center justify-center px-8 xl:px-28 py-12 mb-16 mt-6 bg-[#f3f4f6]"
  >
    <div class="flex flex-col gap-2">
      <h2
        class="text-3xl xl:text-5xl font-bold fs-condensed text-appBlack text-center"
      >
        ¿NECESITAS AYUDA CON TU BATERÍA?
      </h2>
      <p class="text-center text-appBlack text-xs xl:text-base font-medium">
        Contáctanos por WhatsApp para diagnóstico, carga e instalación
        completamente gratuita.
      </p>
    </div>
    <div class="flex flex-col xl:flex-row gap-2 mt-6">
      <a
        href="https://wa.me/50422834540?text=Hola,%20necesito%20cotizar%20una%20batería.%20¿Podrían%20ayudarme?"
        class="flex gap-2 bg-whatsappGreen text-white px-8 py-2 rounded-md fs-condensed hover:scale-105 transition-all duration-300"
      >
        <img
          src="/allas-icons/whatsapp-outline.svg"
          alt="WhatsApp"
          class="w-auto h-6"
        />
        +504 2283-4550
      </a>
    </div>
  </section> `,
})
export class NecesitasAyudaConTuBateria {}
